import { Injectable } from '@angular/core';
import { AuthService } from '../../../../../core';
import { UsuarioPerfil, isPerfilAdministrador } from '../../../../usuario/usuario-perfil';
import { isStatusEmAndamento } from '../../status';

/** Service que valida os acessos e execuções de funcionalidades de encerramento das campanhas */
@Injectable({
    providedIn: 'root'
})
export class CampanhaEncerramentoAuthGuardService {

    constructor(private authService: AuthService) { }

    /** Verifica se pode encerrar a campanha */
    canEncerrar(idCampanha: number, status: number): boolean {
        if (!idCampanha || idCampanha < 0) {
            return false;
        }

        // Somente permite encerrar a campanha se estiver com status igual a "Em Andamento" e se for um admin ou atendente
        return isStatusEmAndamento(status) && (this.authService.isAdministrador() || this.authService.isAtendente() || this.authService.isFinanceiro());
    }
}
